import { X } from 'lucide-react'
import type { ReactNode } from 'react'

// テーブル行選択時の一括操作バー枠（docs/develop/client_ui/components/data-table.md「行の選択と一括操作」）。
// 未選択時は呼び出し側で描画しないこと（disabled のボタン列を常置しない）。
//
// 「N 件を選択中」とアクション群は横に並べるだけで、右寄せ（ml-auto）はしない。
// 帯の幅が足りないとき、アクション群だけが次の行へ回り、選択件数の真下に左揃えで並ぶようにするため
// （右寄せにすると、折り返した行のボタンが帯の中途半端な位置に浮いて崩れて見える。
//  2026/08/31 「発注照合で選択すると選択中〜アクション〜ページャの行が崩れる」FBで方針化）。
//
// 2 つの塊に付けた min-h-9 は、どちらも帯 1 行ぶんの高さ（min-h-14 − py-2.5×2 = 36px）だが役割が違う:
// - 件数側 … 1 行目の高さを確定させる。これが無いと右端のページャ（self-start で 1 行目に固定）と
//   上下の中心線がずれる
// - アクション側 … 折り返して 2 行目に回ったときの行の高さを 1 行目と揃える（見た目の揃え）
// 同じ画面に SelectionActionBar を 2 つ置くと data-testid が重複するので、置かない前提
export function SelectionActionBar({
  selectedCount,
  onClear,
  actions,
}: {
  selectedCount: number
  onClear: () => void
  actions: ReactNode
}) {
  return (
    <>
      {/* 折り返し位置の退行（アクション群が中途半端な位置に浮く）を storybook の
          getBoundingClientRect で機械的に検出できるよう、2つの塊それぞれに testid を付ける */}
      <div className="flex min-h-9 items-center gap-2" data-testid="selection-action-bar-info">
        <span
          className="inline-flex min-w-6 items-center justify-center rounded-full bg-primary px-2 py-0.5 text-sm font-semibold text-primary-foreground"
          // 選択件数はテストで機械可読に特定できるようにする（裸のテキスト一致だと
          // 同じ数字の span が増えたときに複数一致で壊れるため）
          data-testid="selection-action-bar-count"
        >
          {selectedCount}
        </span>
        <span className="text-sm font-medium text-foreground">件を選択中</span>
        <button
          type="button"
          onClick={onClear}
          className="ml-1 inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-xs font-medium text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          <X className="size-3.5" />
          選択を解除
        </button>
      </div>
      <div className="flex min-h-9 flex-wrap items-center gap-2" data-testid="selection-action-bar-actions">
        {actions}
      </div>
    </>
  )
}
